export var avatarWithDetailsTheme = {
  baseStyle: _ref => {
    var {
      isAvatarHover,
      isSelected
    } = _ref;
    return {
      container: {
        display: 'flex',
        alignItems: 'center',
        gap: 's',
        height: '44px'
      },
      avatarContainer: {
        position: 'relative',
        _disabled: {
          pointerEvents: 'none'
        }
      },
      avatar: {
        opacity: isAvatarHover || isSelected ? '0' : '1',
        transition: 'opacity 0.2s ease'
      },
      checkbox: {
        position: 'absolute',
        inset: '0',
        display: 'flex',
        width: '100%',
        height: 'auto',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: isAvatarHover || isSelected ? '1' : '0',
        transition: 'opacity 0.2s ease'
      }
    };
  }
};
//# sourceMappingURL=AvatarWithDetails.theme.js.map